import React from 'react';
import PropTypes from 'prop-types';
import './CollaborationSettingsPanel.scss';

import UserCollaborationsPanel from '../../../Profile/UserCollaborationsPanel';

const CollaborationSettingsPanel = props => {
  return (
    <div className='collaboration-settings-panel-outer'>
      <div className='collaboration-settings-panel-inner'>
        <UserCollaborationsPanel collaborationUser={props.user.profile} />
      </div>
    </div>
  );
};

CollaborationSettingsPanel.propTypes = {
  user: PropTypes.object.isRequired
};

export default CollaborationSettingsPanel;
